$(function () {
	async function init(url) {
		if (!document.querySelector(".b-pdf-viewer")) {
			return;
		}

		const loadDocPromise = pdfjsLib.getDocument(url);
		const pdf = await loadDocPromise.promise;

		const DEFAULT_SCALE = 1.0;
		const CSS_UNITS = 96 / 72;
		const RATIO = 210 / 297;
		const container = document.querySelector(".b-pdf-viewer__pages");

		pdf.getPage(1).then(pdfPage => {
			const viewport = pdfPage.getViewport({scale: DEFAULT_SCALE});
			const scale = container.clientWidth / (viewport.width);

			const newPage = document.createElement('canvas');
			const contextPage = newPage.getContext('2d');
			newPage.width = container.clientWidth;
			newPage.height = container.clientWidth / RATIO;

			const newViewport = pdfPage.getViewport({scale});

			const renderContext = {
				canvasContext: contextPage,
				viewport: newViewport,
			};

			const page = document.createElement('a');

			page.setAttribute('href', url);
			page.setAttribute('target', '_blank');
			page.classList.add('b-pdf-viewer__page');
			page.appendChild(newPage);
			container.appendChild(page);
			pdfPage.render(renderContext);
		});
	}

	window.createPDFViewer = (url) => {
		init(url);
	}
});
